package br.com.texeratx.boardgametimeapp.ui.spotifydevices

import br.com.texeratx.boardgametimeapp.core.spotify.api.SpotifyDeviceDto

data class SpotifyDevicesUiState(
    val isLoading: Boolean = false,
    val devices: List<SpotifyDeviceDto> = emptyList(),
    val selectedDeviceId: String? = null,
    val error: String? = null
)